import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';
import { useEffect } from "react";
import { useState } from "react";
import dayjs from "utils/dayjs";
import { getMgmtDiagnosisResultsById } from "components/axios/mgmtDiagnosisResultAxios";
import { fromServerFormat } from "components/date_picker/dateUtils";

const DiagnosisResultViewSetting = () => {
  const { t } = useTranslation();

  const {id} = useParams();

  const [result, setResult] = useState({});

  useEffect(() => {
    if (id) {
      getMgmtDiagnosisResultsById(id).then((res) => {
        setResult(res)
      })
    }
  }, [id])
  
  const VibrationMuiTable = ({ vibrations }) => {
      const rowSpanPerSensor = 5; 
      return (
        <TableContainer component={Paper} style={{border : '2px double #b1aeaeff'}}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.select.sensor')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.item')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.axis')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.radius')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.vertical')}</TableCell>
              </TableRow>
            </TableHead>
  
            <TableBody>
              {vibrations.map((vib, pIdx) => {
                const partName = vib.equipmentPart.masterEquipmentPart.name;
                const partPos = vib.equipmentPart.componentLocation.name;
                const partLabel = `${partName} ${partPos}`;
  
                const sensorCount = vib.list.length;
                const totalRowSpan = sensorCount * rowSpanPerSensor;
  
                return vib.list.map((sensor, sIdx) => {
                  const sensorLabel =
                    `${sensor.sensorPosition.sensorType}${sensor.sensorPosition.positionNoBySensorType}`;
  
                  const d = sensor.list[0];
  
                  return (
                    <React.Fragment key={`${pIdx}-${sIdx}`}>
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        {sIdx === 0 && (
                          <TableCell align="center" rowSpan={totalRowSpan}>
                            {partLabel}
                          </TableCell>
                        )}
  
                        <TableCell align="center" rowSpan={rowSpanPerSensor}>
                          {sensorLabel}
                        </TableCell>
  
                        <TableCell align="center">{t('message.common.subtitle.vibration.rate')}</TableCell>
                        <TableCell align="center">{d.overallShaft}</TableCell>
                        <TableCell align="center">{d.overallHorizon}</TableCell>
                        <TableCell align="center">{d.overallVertical}</TableCell>
                      </TableRow>
  
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        <TableCell align="center">{t('message.common.subtitle.grade')}</TableCell>
                        <TableCell align="center">{d.rankShaft}</TableCell>
                        <TableCell align="center">{d.rankHorizon}</TableCell>
                        <TableCell align="center">{d.rankVertical}</TableCell>
                      </TableRow>
  
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        <TableCell align="center">{t('message.common.subtitle.abnormality')}</TableCell>
                        <TableCell align="center">{d.abnormalCheckShaft}</TableCell>
                        <TableCell align="center">{d.abnormalCheckHorizon}</TableCell>
                        <TableCell align="center">{d.abnormalCheckVertical}</TableCell>
                      </TableRow>
  
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        <TableCell align="center">{t('message.common.subtitle.diagnosis.code')}</TableCell>
                        <TableCell align="center">{d.analysisResultShaft}</TableCell>
                        <TableCell align="center">{d.analysisResultHorizon}</TableCell>
                        <TableCell align="center">{d.analysisResultVertical}</TableCell>
                      </TableRow>
  
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        <TableCell align="center">ML {t('message.common.subtitle.abnormality')}</TableCell>
                        <TableCell align="center" colSpan={3}>
                          {d.mlAbnormalCheck}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                });
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    };
    
    const NoiseMuiTable = ({ noises }) => {
      const rowSpanPerSensor = 4; 
      return (
        <TableContainer component={Paper} style={{border : '2px double #b1aeaeff'}}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.select.sensor')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.item')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.value')}</TableCell>
              </TableRow>
            </TableHead>
  
            <TableBody>
              {noises.map((noi, pIdx) => {
                const partName = noi.equipmentPart.masterEquipmentPart.name;
                const partPos = noi.equipmentPart.componentLocation.name;
                const partLabel = `${partName} ${partPos}`;
  
                const sensorCount = noi.list.length;
                const totalRowSpan = sensorCount * rowSpanPerSensor;
  
                return noi.list.map((sensor, sIdx) => {
                  const sensorLabel =
                    `${sensor.sensorPosition.sensorType}${sensor.sensorPosition.positionNoBySensorType}`;
  
                  const d = sensor.list[0];
  
                  return (
                    <React.Fragment key={`${pIdx}-${sIdx}`}>
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        {sIdx === 0 && (
                          <TableCell align="center" rowSpan={totalRowSpan}>
                            {partLabel}
                          </TableCell>
                        )}
  
                        <TableCell align="center" rowSpan={rowSpanPerSensor}>
                          {sensorLabel}
                        </TableCell>
  
                        <TableCell align="center">{t('message.common.subtitle.kurtosis')}</TableCell>
                        <TableCell align="center">{d.kurtosis}</TableCell>
                      </TableRow>
  
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        <TableCell align="center">RMS</TableCell>
                        <TableCell align="center">{d.rms}</TableCell>
                      </TableRow>
  
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        <TableCell align="center">{t('message.common.subtitle.skewness')}</TableCell>
                        <TableCell align="center">{d.skew}</TableCell>
                      </TableRow>
  
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        <TableCell align="center">{t('message.common.subtitle.noise.issue')}</TableCell>
                        <TableCell align="center">{d.abnormalCheck}</TableCell>
                      </TableRow>
  
                    </React.Fragment>
                  );
                });
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    };
  
    const ChainMuiTable = ({ chains }) => {
      const rowSpanPerSensor = 1; 
      return (
        <TableContainer component={Paper} style={{border : '2px double #b1aeaeff'}}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.elongation')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.length')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.twist')}</TableCell>
              </TableRow>
            </TableHead>
  
            <TableBody>
              {chains.map((vib, pIdx) => {
                const partName = vib.equipmentPart.masterEquipmentPart.name;
                const partPos = vib.equipmentPart.componentLocation.name;
                const partLabel = `${partName} ${partPos}`;
  
                const sensorCount = vib.list.length;
                const totalRowSpan = sensorCount * rowSpanPerSensor;
  
                return vib.list.map((d, dIdx) => {
                  return (
                    <React.Fragment key={`${pIdx}-${dIdx}`}>
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        {dIdx === 0 && (
                          <TableCell align="center" rowSpan={totalRowSpan}>
                            {partLabel}
                          </TableCell>
                        )}
  
                        <TableCell align="center">{d.elongation}</TableCell>
                        <TableCell align="center">{d.length}</TableCell>
                        <TableCell align="center">{d.twistedYn}</TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                });
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    };
  
    const VbeltMuiTable = ({ vbelts }) => {
      const rowSpanPerSensor = 1; 
      return (
        <TableContainer component={Paper} style={{border : '2px double #b1aeaeff'}}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.elongation')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.length')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.belt.shake')}</TableCell>
              </TableRow>
            </TableHead>
  
            <TableBody>
              {vbelts.map((vib, pIdx) => {
                const partName = vib.equipmentPart.masterEquipmentPart.name;
                const partPos = vib.equipmentPart.componentLocation.name;
                const partLabel = `${partName} ${partPos}`;
  
                const sensorCount = vib.list.length;
                const totalRowSpan = sensorCount * rowSpanPerSensor;
  
                return vib.list.map((d, dIdx) => {
                  return (
                    <React.Fragment key={`${pIdx}-${dIdx}`}>
                      <TableRow style={{border : '1px solid #8f8e8eff'}}>
                        {dIdx === 0 && (
                          <TableCell align="center" rowSpan={totalRowSpan}>
                            {partLabel}
                          </TableCell>
                        )}
  
                        <TableCell align="center">{d.elongation}</TableCell>
                        <TableCell align="center">{d.length}</TableCell>
                        <TableCell align="center">{d.saggingYn}</TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                });
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    };

    return (
      <div style={{padding:"15px 20px 0px 0px"}}>
        <TableContainer key={0}>
          <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
            <TableBody>
              <TableRow>
                <TableCell className="th" style={{width:'200px'}}>{t('message.common.subtitle.diagnosis.datetime')}</TableCell>
                <TableCell className="view_td2">
                  {fromServerFormat(result.analysisAt,{format:t('message.common.text.date.format.datetimess')})}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.company.name')}</TableCell>
                <TableCell className="view_td2">
                  {result.equipment?.managementCompany?.info?.name ?? ''}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                <TableCell className="view_td2">
                  {result.equipment?.name ?? ''}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.equipment.number')}</TableCell>
                <TableCell className="view_td2">
                  {result.equipment?.equipmentNo ?? ''}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                <TableCell className="view_td2">
                  {result.equipment?.equipmentCtgr?.parent?.parent?.name ?? ''} 
                  &gt; {result.equipment?.equipmentCtgr?.parent?.name ?? ''} 
                  &gt; {result.equipment?.equipmentCtgr?.name ?? ''} 
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('menu.cmms.management.diagnosis.result')}</TableCell>
                <TableCell className="view_td2">
                  <div style={{ maxHeight: "550px", overflowY: "auto", padding: "6px", scrollbarWidth : "none" }}>
                  {result.vibrations && result.vibrations.length > 0 &&
                    <VibrationMuiTable vibrations={result.vibrations} />
                  }
                  <br/>
                  {result.noises && result.noises.length > 0 &&
                    <NoiseMuiTable noises={result.noises} />
                  }
                  <br/>
                  {result.chains && result.chains.length > 0 &&
                    <ChainMuiTable chains={result.chains} />
                  }
                  <br/>
                  {result.vbelts && result.vbelts.length > 0 &&
                    <VbeltMuiTable vbelts={result.vbelts} />
                  }
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    )
}

export default DiagnosisResultViewSetting;